module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/device/device.component.css
// module id = ./src/app/device/device.component.css
// module chunks = main